export const breakpoints = {
  0: {
    slidesPerView: 1,
  },
  650: {
    slidesPerView: 1,
  },
  900: {
    slidesPerView: 2,
  },
  1220: {
    slidesPerView: 3,
  },
  1350: {
    slidesPerView: 3,
  },
  1620: {
    slidesPerView: 4,
  },
  1900: {
    slidesPerView: 5,
  },
  2300: {
    slidesPerView: 6,
  },
};
